import { render } from "./friendsPage.vue?vue&type=template&id=e27ec358"
import script from "./friendsPage.vue?vue&type=script&lang=js"
export * from "./friendsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__